import { handleActions } from 'redux-actions';

import { actions } from '../actions/confirmModal';

const {
  confirmModalShow,
  confirmModalHide,
  confirmModalCancel,
  confirmModalConfirm,
} = actions;

export interface ConfirmModalState {
  confirmModal: State;
}

export interface State {
  isShown: boolean;
  headline: string;
  text: string;
  cancelText: string;
  confirmText: string;
}

const initialState: State = {
  isShown: false,
  headline: '',
  text: '',
  cancelText: 'Cancel',
  confirmText: '',
};

const confirmModal = handleActions<State, any>(
  {
    [confirmModalShow.toString()]: (state, action) => {
      return {
        ...state,
        isShown: true,
        headline: action.payload.headline,
        text: action.payload.text,
        cancelText: action.payload.cancelText || 'Cancel',
        confirmText: action.payload.confirmText,
      };
    },
    [confirmModalHide.toString()]: (state, action) => {
      return { ...state, isShown: false };
    },
    [confirmModalCancel.toString()]: (state, action) => {
      return { ...state, isShown: false };
    },
    [confirmModalConfirm.toString()]: (state, action) => {
      return { ...state, isShown: false };
    },
  },
  initialState,
);

export default confirmModal;
